﻿package com.milta.core.localization.translations.es

import com.milta.core.localization.ProfileStrings

internal val Profile = ProfileStrings(
    screenTitle = "Mi perfil",
    sectionPersonal = "Información personal",
    labelFirstName = "Nombre",
    labelLastName = "Apellido",
    labelRole = "Rol",
    sectionLanguage = "Idioma",
    labelLanguage = "Idioma de la aplicación",
    changeLanguageButton = "Cambiar idioma",
    languageDialogTitle = "Elige tu idioma",
    languageDialogConfirm = "Confirmar",
    languageDialogCancel = "Cancelar",
    sectionPassword = "Seguridad",
    labelCurrentPassword = "Contraseña actual",
    labelNewPassword = "Nueva contraseña",
    changePasswordButton = "Cambiar contraseña",
    successLanguageUpdated = "Idioma actualizado con éxito",
    successPasswordChanged = "Contraseña cambiada con éxito",
    errorProfileNotFound = "Perfil no encontrado",
    errorCurrentPasswordRequired = "Introduce tu contraseña actual",
    errorCurrentPasswordTooLong = "La contraseña actual no puede superar los 128 caracteres",
    errorNewPasswordRequired = "Introduce una nueva contraseña",
    errorNewPasswordTooShort = "La nueva contraseña debe tener al menos 8 caracteres",
    errorNewPasswordTooLong = "La nueva contraseña no puede superar los 128 caracteres",
    errorLanguageRequired = "Selecciona un idioma",
    errorForbidden = "No estás autorizado para realizar esta acción",
    errorValidation = "Los datos proporcionados no son válidos",
    errorGeneric = "Se ha producido un error. Inténtalo de nuevo.",
    signOut = "Cerrar sesión",
    deleteAccount = "Eliminar cuenta",
    menuLanguage = "Idioma de la interfaz",
    menuPassword = "Cambiar contraseña",
    menuSubscription = "Mi suscripción",
    menuPrivacy = "Privacidad y RGPD",
    linkedCodeLabel = "Código de enlace único",
    copyCode = "Copiar",
    codeCopied = "¡Copiado!",
    modeOrganisation = "Empresa",
    modeDriver = "Conductor",
    roleDriver = "Conductor",
    roleOrganisation = "Empresa",
    modeSwitchTitle = "Cambiar de modo",
    modeSwitchHint = "Cambia entre el modo Empresa y el modo Conductor en cualquier momento",
    switchToEnterprise = "Modo Empresa",
    switchToDriver = "Modo Conductor",
    menuPhone = "Número de teléfono",
    phoneOtpStepTitle = "Código de verificación enviado por SMS",
    successPhoneUpdated = "Número de teléfono actualizado",
    deleteAccountDialogTitle = "¿Eliminar tu cuenta?",
    deleteAccountDialogMessage = "Esta acción es irreversible. Se eliminará tu información personal. Se enviará un código de verificación por SMS para confirmar.",
    deleteAccountDialogConfirm = "Continuar",
    deleteAccountOtpStepTitle = "Código de verificación enviado por SMS",
    deleteAccountConfirmButton = "Eliminar definitivamente",
    errorLastEnterpriseOwner = "Eres el único gestor de tu empresa. Añade otra cuenta de Empresa antes de eliminar la tuya.",
    logoutPendingWarningTitle = "Entregas no enviadas",
    logoutPendingWarningMessageSuffix = "entrega(s) pendiente(s) se perderán si cierras sesión ahora.",
    logoutPendingWarningConfirm = "Cerrar sesión de todos modos",
    logoutPendingWarningCancel = "Cancelar",
    modeSwitchActiveRouteWarningTitle = "Ruta en curso",
    modeSwitchActiveRouteWarningMessage = "Actualmente hay una ruta en curso. Cambiar de modo te alejará de su seguimiento. ¿Continuar?",
    modeSwitchActiveRouteWarningConfirm = "Cambiar de todos modos",
    modeSwitchActiveRouteWarningCancel = "Cancelar",
)

